import { set_product} from "../confg";
import {combineReducers, createReducer} from '@reduxjs/toolkit'


const product=createReducer(null, {
    [set_product]: (state, action) => {
        return action.payload
    }
});
export default combineReducers({product})